import React from 'react';
import { services } from '../data/content';
import useReveal from '../hooks/useReveal';
import './Services.css';

function ServiceCard({ icon, name, desc }) {
  const ref = useReveal();
  return (
    <div className="service-card" ref={ref}>
      <div className="service-card__icon">{icon}</div>
      <h3 className="service-card__name">{name}</h3>
      <p className="service-card__desc">{desc}</p>
    </div>
  );
}

export default function Services() {
  const headerRef = useReveal();

  return (
    <section className="services" id="services">
      <div className="services__header" ref={headerRef}>
        <div>
          <span className="section-label">What We Offer</span>
          <h2 className="section-title">
            Our <em>Services</em>
          </h2>
        </div>
        <a href="#contact" className="btn btn--outline">Request a Quote</a>
      </div>

      <div className="services__grid">
        {services.map((svc) => (
          <ServiceCard key={svc.name} {...svc} />
        ))}
      </div>
    </section>
  );
}
